import styled from "styled-components";

export const PredictionsContainer = styled.div`
  position: absolute;
  left: 0px;
  right: 0px;
  top: 8%;
  margin: 2% 2% 2% 0%;
`